export const environment = {
  production: false,
  apiUrl: 'https://osconnectqa.coricraft.co.za/', // Coricraft Omni Procurement QA
  // apiUrl: 'https://localhost:44352/', // Coricraft Omni Procurement QA
  appVersion: '2.0.5',
  apiVersion: 'v1',
  appCode: 'PORTAL-BASE',
  mainMenuKey: 'MAIN',
  toolbarHeight: 64,
  tableMarginBottom: 0,
  reportPath: "api/reports",
  subfolder: '',
};
